import React, { useEffect, useState } from "react";
import "./Products.css";

import {
  FaSearch,
  FaTools,
  FaFaucet,
  FaStar,
  FaDoorOpen,
} from "react-icons/fa";

const API_URL =
  "https://etoile-bricolage-api.imanehibouzid2001.workers.dev";

function Products() {
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // =====================================================
  // LES 4 CATEGORIES DU SITE
  // =====================================================

  const categoryConfig = [
    {
      name: "Quincaillerie",
      title: "QUINCAILLERIE",
      icon: <FaDoorOpen />,
    },
    {
      name: "Outils",
      title: "OUTILS",
      icon: <FaTools />,
    },
    {
      name: "Sanitaires",
      title: "SANITAIRES",
      icon: <FaFaucet />,
    },
    {
      name: "Marque Etoile",
      title: "MARQUE ETOILE",
      icon: <FaStar />,
    },
  ];

  // =====================================================
  // RECUPERATION DES PRODUITS DEPUIS L'API
  // =====================================================

  useEffect(() => {
    const loadProducts = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await fetch(
          `${API_URL}/api/products`
        );

        const data = await response.json();

        if (!response.ok || !data.success) {
          throw new Error(
            data.error ||
              "Impossible de récupérer les produits."
          );
        }

        setProducts(data.products || []);
      } catch (err) {
        console.error(
          "Erreur chargement produits :",
          err
        );

        setError(
          "Impossible de charger les produits pour le moment."
        );
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  // =====================================================
  // CREATION DES 4 CATEGORIES
  // =====================================================

  const categories = categoryConfig.map((category) => ({
    ...category,

    products: products.filter(
      (product) =>
        product.category_name === category.name
    ),
  }));

  // =====================================================
  // RECHERCHE UNIQUEMENT PAR CATEGORIE
  // =====================================================

  const filteredCategories = categories.filter(
    (category) =>
      category.title
        .toLowerCase()
        .includes(search.toLowerCase())
  );

  // =====================================================
  // AFFICHAGE
  // =====================================================

  return (
    <main>
      <section className="products-section">

        {/* TITRE */}

        <h1 className="products-title">
          Nos Produits
        </h1>

        {/* BARRE DE RECHERCHE */}

        <div className="search-bar">
          <input
            type="text"
            placeholder="Chercher une catégorie..."
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
          />

          <button type="button">
            <FaSearch />
            Chercher
          </button>
        </div>

        {/* CHARGEMENT */}

        {loading && (
          <div className="products-api-message">
            Chargement des produits...
          </div>
        )}

        {/* ERREUR */}

        {error && (
          <div className="products-api-error">
            {error}
          </div>
        )}

        {/* =================================================
            LES 4 CATEGORIES
        ================================================= */}

        {!loading &&
          !error &&
          filteredCategories.map((category) => (
            <div
              key={category.name}
              className="category"
            >

              {/* TITRE CATEGORIE */}

              <h2>
                <span className="category-icon">
                  {category.icon}
                </span>

                {category.title}
              </h2>

              {/* PRODUITS DE LA CATEGORIE */}

              {category.products.length > 0 && (
                <div className="products-grid">

                  {category.products.map(
                    (product) => (
                      <div
                        key={product.id}
                        className="product-card"
                      >

                        {/* IMAGE */}

                        <img
                          src={product.image_url}
                          alt={
                            product.name ||
                            "Produit Étoile Bricolage"
                          }
                          onError={(e) => {
                            e.currentTarget.style.display =
                              "none";
                          }}
                        />

                        {/* NOM FACULTATIF */}

                        {product.name &&
                          product.name.trim() && (
                            <p className="product-name">
                              {product.name}
                            </p>
                          )}

                        {/* DESCRIPTION FACULTATIVE */}

                        {product.description &&
                          product.description.trim() && (
                            <p className="product-ref">
                              {product.description}
                            </p>
                          )}

                      </div>
                    )
                  )}

                </div>
              )}

            </div>
          ))}

        {/* AUCUNE CATEGORIE TROUVEE */}

        {!loading &&
          !error &&
          filteredCategories.length === 0 && (
            <div className="products-api-message">
              Aucune catégorie trouvée.
            </div>
          )}

      </section>
    </main>
  );
}

export default Products;